import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

interface IModalProps extends ModalContextType {
    setActiveTab: (tab: number) => void;
}

export default function DentalEnrollmentRequirementModal({ closeModal, setActiveTab }: IModalProps) {
    const { exchangeName } = useAppSelector(environmentSelector);

    function onClose(e) {
        e?.preventDefault();
        closeModal('dentalEnrollmentRequirement');
        // The 0th tab is the Heatlh Plan tab and 1 is the Dental Plan tab. 
        setActiveTab?.(0);
    }

    return (
        <Modal id="dentalEnrollmentRequirementModal">
            <Modal.Header id="dentalEnrollmentRequirementModalHeader" titleId="customGrouping.customGrouping" onHide={onClose} />
            <Modal.Body id="dentalEnrollmentRequirementModalBody">
                <p>
                    <FormattedMessage id="customGrouping.error.dentalNoHealthPlan" values={{ exchangeName }} />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="dentalEnrollmentRequirementModalShopForHealthButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="customGrouping.shopForHealth" 
                />
            </Modal.Controls>
        </Modal>
    );
}
